import { Combobox, Option, Label, makeStyles, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, tokens } from "@fluentui/react-components";
import LinkWithIcon from "../../LinkWithIcon";
import { useState } from "react";

const useStyles = makeStyles({
    buildDropdown: {
        display: "flex",
        gap: "5px",
        alignItems: "center"
    }
});

export default function FlightOps_Overview_AudienceAdoption() {
    const styles = useStyles();
    const [ selectedBuild, setSelectedBuild ] = useState<string | null>( null );
    const [ buildValue, setBuildValue ] = useState<string | null>( null );

    return (
        <>
            <p>
                Select a build to view adoption rates and audience insights. Audience adoption data is only available for builds that have been promoted to a ring and has been seen by users.
            </p>

             <div className={styles.buildDropdown}>
                <Label htmlFor={"flightOpsBuildSelection"}>Build</Label>
                <Combobox id={"flightOpsBuildSelection"}
                          value={ buildValue ?? "" }
                          placeholder="Select build..."
                          selectedOptions={ selectedBuild ? [ selectedBuild ] : [] }
                          onOptionSelect={( _, d ) => {
                              const v = d.optionValue as string;
                              if( v ) {
                                setSelectedBuild( v );
                                setBuildValue( d.optionText as string );
                              }
                          }}
                          onChange={( e ) => {
                              setBuildValue( e.target.value );
                          }}
                          style={{ maxWidth: "200px" }}>
                    <Option key={"bld_1"} value="asdfghjkl">1.0.0.0</Option>
                </Combobox>
            </div>

        </>
    );
}